/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedRegisterGuestRouteImport } from './routes/_authenticated/register-guest'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedInstallGuideRouteImport } from './routes/_authenticated/install-guide'
import { Route as AuthenticatedFeedRouteImport } from './routes/_authenticated/feed'
import { Route as AuthenticatedEventsRouteImport } from './routes/_authenticated/events'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedAboutRouteImport } from './routes/_authenticated/about'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/_admin'
import { Route as AuthenticatedNotificationsIndexRouteImport } from './routes/_authenticated/notifications.index'
import { Route as AuthenticatedFeedIndexRouteImport } from './routes/_authenticated/feed.index'
import { Route as AuthenticatedEventsIndexRouteImport } from './routes/_authenticated/events.index'
import { Route as AuthenticatedAccountIndexRouteImport } from './routes/_authenticated/account.index'
import { Route as AuthenticatedNotificationsNotificationIdRouteImport } from './routes/_authenticated/notifications.$notificationId'
import { Route as AuthenticatedFeedPostIdRouteImport } from './routes/_authenticated/feed.$postId'
import { Route as AuthenticatedEventsNewRouteImport } from './routes/_authenticated/events.new'
import { Route as AuthenticatedEventsEventIdRouteImport } from './routes/_authenticated/events.$eventId'
import { Route as AuthenticatedAccountSettingsRouteImport } from './routes/_authenticated/account.settings'
import { Route as AuthenticatedAccountFeedbackRouteImport } from './routes/_authenticated/account.feedback'
import { Route as AuthenticatedAccountEditRouteImport } from './routes/_authenticated/account.edit'
import { Route as AuthenticatedAdminAdminRouteImport } from './routes/_authenticated/_admin/admin'
import { Route as AuthenticatedAdminAdminIndexRouteImport } from './routes/_authenticated/_admin/admin.index'
import { Route as AuthenticatedEventsEventIdEditRouteImport } from './routes/_authenticated/events.$eventId.edit'
import { Route as AuthenticatedEventsEventIdAttendanceRouteImport } from './routes/_authenticated/events.$eventId.attendance'
import { Route as AuthenticatedAdminAdminModeratePostsRouteImport } from './routes/_authenticated/_admin/admin.moderate-posts'
import { Route as AuthenticatedAdminAdminManageUsersRouteImport } from './routes/_authenticated/_admin/admin.manage-users'
import { Route as AuthenticatedAdminAdminManageRolesRouteImport } from './routes/_authenticated/_admin/admin.manage-roles'
import { Route as AuthenticatedAdminAdminManageGroupsRouteImport } from './routes/_authenticated/_admin/admin.manage-groups'
import { Route as AuthenticatedAdminAdminGuestLogRouteImport } from './routes/_authenticated/_admin/admin.guest-log'
import { Route as AuthenticatedEventsEventIdAttendanceAddRouteImport } from './routes/_authenticated/events.$eventId.attendance.add'
import { Route as AuthenticatedAdminAdminManageUsersImportRouteImport } from './routes/_authenticated/_admin/admin.manage-users.import'
import { Route as AuthenticatedAdminAdminManageRolesNewRouteImport } from './routes/_authenticated/_admin/admin.manage-roles.new'
import { Route as AuthenticatedAdminAdminManageRolesRoleIdRouteImport } from './routes/_authenticated/_admin/admin.manage-roles.$roleId'
import { Route as AuthenticatedAdminAdminManageGroupsGroupIdRouteImport } from './routes/_authenticated/_admin/admin.manage-groups.$groupId'
import { Route as AuthenticatedAdminAdminManageRolesRoleIdEditRouteImport } from './routes/_authenticated/_admin/admin.manage-roles.$roleId.edit'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRegisterGuestRoute =
  AuthenticatedRegisterGuestRouteImport.update({
    id: '/register-guest',
    path: '/register-guest',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInstallGuideRoute =
  AuthenticatedInstallGuideRouteImport.update({
    id: '/install-guide',
    path: '/install-guide',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFeedRoute = AuthenticatedFeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEventsRoute = AuthenticatedEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAboutRoute = AuthenticatedAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotificationsIndexRoute =
  AuthenticatedNotificationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedNotificationsRoute,
  } as any)
const AuthenticatedFeedIndexRoute = AuthenticatedFeedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedFeedRoute,
} as any)
const AuthenticatedEventsIndexRoute =
  AuthenticatedEventsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedEventsRoute,
  } as any)
const AuthenticatedAccountIndexRoute =
  AuthenticatedAccountIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedNotificationsNotificationIdRoute =
  AuthenticatedNotificationsNotificationIdRouteImport.update({
    id: '/$notificationId',
    path: '/$notificationId',
    getParentRoute: () => AuthenticatedNotificationsRoute,
  } as any)
const AuthenticatedFeedPostIdRoute = AuthenticatedFeedPostIdRouteImport.update({
  id: '/$postId',
  path: '/$postId',
  getParentRoute: () => AuthenticatedFeedRoute,
} as any)
const AuthenticatedEventsNewRoute = AuthenticatedEventsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedEventsRoute,
} as any)
const AuthenticatedEventsEventIdRoute =
  AuthenticatedEventsEventIdRouteImport.update({
    id: '/$eventId',
    path: '/$eventId',
    getParentRoute: () => AuthenticatedEventsRoute,
  } as any)
const AuthenticatedAccountSettingsRoute =
  AuthenticatedAccountSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountFeedbackRoute =
  AuthenticatedAccountFeedbackRouteImport.update({
    id: '/feedback',
    path: '/feedback',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountEditRoute =
  AuthenticatedAccountEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAdminAdminRoute = AuthenticatedAdminAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminAdminIndexRoute =
  AuthenticatedAdminAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAdminAdminRoute,
  } as any)
const AuthenticatedEventsEventIdEditRoute =
  AuthenticatedEventsEventIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedEventsEventIdAttendanceRoute =
  AuthenticatedEventsEventIdAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => AuthenticatedEventsEventIdRoute,
  } as any)
const AuthenticatedAdminAdminModeratePostsRoute =
  AuthenticatedAdminAdminModeratePostsRouteImport.update({
    id: '/moderate-posts',
    path: '/moderate-posts',
    getParentRoute: () => AuthenticatedAdminAdminRoute,
  } as any)
const AuthenticatedAdminAdminManageUsersRoute =
  AuthenticatedAdminAdminManageUsersRouteImport.update({
    id: '/manage-users',
    path: '/manage-users',
    getParentRoute: () => AuthenticatedAdminAdminRoute,
  } as any)
const AuthenticatedAdminAdminManageRolesRoute =
  AuthenticatedAdminAdminManageRolesRouteImport.update({
    id: '/manage-roles',
    path: '/manage-roles',
    getParentRoute: () => AuthenticatedAdminAdminRoute,
  } as any)
const AuthenticatedAdminAdminManageGroupsRoute =
  AuthenticatedAdminAdminManageGroupsRouteImport.update({
    id: '/manage-groups',
    path: '/manage-groups',
    getParentRoute: () => AuthenticatedAdminAdminRoute,
  } as any)
const AuthenticatedAdminAdminGuestLogRoute =
  AuthenticatedAdminAdminGuestLogRouteImport.update({
    id: '/guest-log',
    path: '/guest-log',
    getParentRoute: () => AuthenticatedAdminAdminRoute,
  } as any)
const AuthenticatedEventsEventIdAttendanceAddRoute =
  AuthenticatedEventsEventIdAttendanceAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => AuthenticatedEventsEventIdAttendanceRoute,
  } as any)
const AuthenticatedAdminAdminManageUsersImportRoute =
  AuthenticatedAdminAdminManageUsersImportRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AuthenticatedAdminAdminManageUsersRoute,
  } as any)
const AuthenticatedAdminAdminManageRolesNewRoute =
  AuthenticatedAdminAdminManageRolesNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedAdminAdminManageRolesRoute,
  } as any)
const AuthenticatedAdminAdminManageRolesRoleIdRoute =
  AuthenticatedAdminAdminManageRolesRoleIdRouteImport.update({
    id: '/$roleId',
    path: '/$roleId',
    getParentRoute: () => AuthenticatedAdminAdminManageRolesRoute,
  } as any)
const AuthenticatedAdminAdminManageGroupsGroupIdRoute =
  AuthenticatedAdminAdminManageGroupsGroupIdRouteImport.update({
    id: '/$groupId',
    path: '/$groupId',
    getParentRoute: () => AuthenticatedAdminAdminManageGroupsRoute,
  } as any)
const AuthenticatedAdminAdminManageRolesRoleIdEditRoute =
  AuthenticatedAdminAdminManageRolesRoleIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedAdminAdminManageRolesRoleIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/login': typeof LoginRoute
  '/about': typeof AuthenticatedAboutRoute
  '/account': typeof AuthenticatedAccountRouteWithChildren
  '/events': typeof AuthenticatedEventsRouteWithChildren
  '/feed': typeof AuthenticatedFeedRouteWithChildren
  '/install-guide': typeof AuthenticatedInstallGuideRoute
  '/notifications': typeof AuthenticatedNotificationsRouteWithChildren
  '/register-guest': typeof AuthenticatedRegisterGuestRoute
  '/': typeof AuthenticatedIndexRoute
  '/admin': typeof AuthenticatedAdminAdminRouteWithChildren
  '/account/edit': typeof AuthenticatedAccountEditRoute
  '/account/feedback': typeof AuthenticatedAccountFeedbackRoute
  '/account/settings': typeof AuthenticatedAccountSettingsRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdRouteWithChildren
  '/events/new': typeof AuthenticatedEventsNewRoute
  '/feed/$postId': typeof AuthenticatedFeedPostIdRoute
  '/notifications/$notificationId': typeof AuthenticatedNotificationsNotificationIdRoute
  '/account/': typeof AuthenticatedAccountIndexRoute
  '/events/': typeof AuthenticatedEventsIndexRoute
  '/feed/': typeof AuthenticatedFeedIndexRoute
  '/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/admin/guest-log': typeof AuthenticatedAdminAdminGuestLogRoute
  '/admin/manage-groups': typeof AuthenticatedAdminAdminManageGroupsRouteWithChildren
  '/admin/manage-roles': typeof AuthenticatedAdminAdminManageRolesRouteWithChildren
  '/admin/manage-users': typeof AuthenticatedAdminAdminManageUsersRouteWithChildren
  '/admin/moderate-posts': typeof AuthenticatedAdminAdminModeratePostsRoute
  '/events/$eventId/attendance': typeof AuthenticatedEventsEventIdAttendanceRouteWithChildren
  '/events/$eventId/edit': typeof AuthenticatedEventsEventIdEditRoute
  '/admin/': typeof AuthenticatedAdminAdminIndexRoute
  '/admin/manage-groups/$groupId': typeof AuthenticatedAdminAdminManageGroupsGroupIdRoute
  '/admin/manage-roles/$roleId': typeof AuthenticatedAdminAdminManageRolesRoleIdRouteWithChildren
  '/admin/manage-roles/new': typeof AuthenticatedAdminAdminManageRolesNewRoute
  '/admin/manage-users/import': typeof AuthenticatedAdminAdminManageUsersImportRoute
  '/events/$eventId/attendance/add': typeof AuthenticatedEventsEventIdAttendanceAddRoute
  '/admin/manage-roles/$roleId/edit': typeof AuthenticatedAdminAdminManageRolesRoleIdEditRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/about': typeof AuthenticatedAboutRoute
  '/install-guide': typeof AuthenticatedInstallGuideRoute
  '/register-guest': typeof AuthenticatedRegisterGuestRoute
  '/': typeof AuthenticatedIndexRoute
  '/account/edit': typeof AuthenticatedAccountEditRoute
  '/account/feedback': typeof AuthenticatedAccountFeedbackRoute
  '/account/settings': typeof AuthenticatedAccountSettingsRoute
  '/events/$eventId': typeof AuthenticatedEventsEventIdRouteWithChildren
  '/events/new': typeof AuthenticatedEventsNewRoute
  '/feed/$postId': typeof AuthenticatedFeedPostIdRoute
  '/notifications/$notificationId': typeof AuthenticatedNotificationsNotificationIdRoute
  '/account': typeof AuthenticatedAccountIndexRoute
  '/events': typeof AuthenticatedEventsIndexRoute
  '/feed': typeof AuthenticatedFeedIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/admin/guest-log': typeof AuthenticatedAdminAdminGuestLogRoute
  '/admin/manage-groups': typeof AuthenticatedAdminAdminManageGroupsRouteWithChildren
  '/admin/manage-roles': typeof AuthenticatedAdminAdminManageRolesRouteWithChildren
  '/admin/manage-users': typeof AuthenticatedAdminAdminManageUsersRouteWithChildren
  '/admin/moderate-posts': typeof AuthenticatedAdminAdminModeratePostsRoute
  '/events/$eventId/attendance': typeof AuthenticatedEventsEventIdAttendanceRouteWithChildren
  '/events/$eventId/edit': typeof AuthenticatedEventsEventIdEditRoute
  '/admin': typeof AuthenticatedAdminAdminIndexRoute
  '/admin/manage-groups/$groupId': typeof AuthenticatedAdminAdminManageGroupsGroupIdRoute
  '/admin/manage-roles/$roleId': typeof AuthenticatedAdminAdminManageRolesRoleIdRouteWithChildren
  '/admin/manage-roles/new': typeof AuthenticatedAdminAdminManageRolesNewRoute
  '/admin/manage-users/import': typeof AuthenticatedAdminAdminManageUsersImportRoute
  '/events/$eventId/attendance/add': typeof AuthenticatedEventsEventIdAttendanceAddRoute
  '/admin/manage-roles/$roleId/edit': typeof AuthenticatedAdminAdminManageRolesRoleIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/_admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/about': typeof AuthenticatedAboutRoute
  '/_authenticated/account': typeof AuthenticatedAccountRouteWithChildren
  '/_authenticated/events': typeof AuthenticatedEventsRouteWithChildren
  '/_authenticated/feed': typeof AuthenticatedFeedRouteWithChildren
  '/_authenticated/install-guide': typeof AuthenticatedInstallGuideRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRouteWithChildren
  '/_authenticated/register-guest': typeof AuthenticatedRegisterGuestRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/_admin/admin': typeof AuthenticatedAdminAdminRouteWithChildren
  '/_authenticated/account/edit': typeof AuthenticatedAccountEditRoute
  '/_authenticated/account/feedback': typeof AuthenticatedAccountFeedbackRoute
  '/_authenticated/account/settings': typeof AuthenticatedAccountSettingsRoute
  '/_authenticated/events/$eventId': typeof AuthenticatedEventsEventIdRouteWithChildren
  '/_authenticated/events/new': typeof AuthenticatedEventsNewRoute
  '/_authenticated/feed/$postId': typeof AuthenticatedFeedPostIdRoute
  '/_authenticated/notifications/$notificationId': typeof AuthenticatedNotificationsNotificationIdRoute
  '/_authenticated/account/': typeof AuthenticatedAccountIndexRoute
  '/_authenticated/events/': typeof AuthenticatedEventsIndexRoute
  '/_authenticated/feed/': typeof AuthenticatedFeedIndexRoute
  '/_authenticated/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/_authenticated/_admin/admin/guest-log': typeof AuthenticatedAdminAdminGuestLogRoute
  '/_authenticated/_admin/admin/manage-groups': typeof AuthenticatedAdminAdminManageGroupsRouteWithChildren
  '/_authenticated/_admin/admin/manage-roles': typeof AuthenticatedAdminAdminManageRolesRouteWithChildren
  '/_authenticated/_admin/admin/manage-users': typeof AuthenticatedAdminAdminManageUsersRouteWithChildren
  '/_authenticated/_admin/admin/moderate-posts': typeof AuthenticatedAdminAdminModeratePostsRoute
  '/_authenticated/events/$eventId/attendance': typeof AuthenticatedEventsEventIdAttendanceRouteWithChildren
  '/_authenticated/events/$eventId/edit': typeof AuthenticatedEventsEventIdEditRoute
  '/_authenticated/_admin/admin/': typeof AuthenticatedAdminAdminIndexRoute
  '/_authenticated/_admin/admin/manage-groups/$groupId': typeof AuthenticatedAdminAdminManageGroupsGroupIdRoute
  '/_authenticated/_admin/admin/manage-roles/$roleId': typeof AuthenticatedAdminAdminManageRolesRoleIdRouteWithChildren
  '/_authenticated/_admin/admin/manage-roles/new': typeof AuthenticatedAdminAdminManageRolesNewRoute
  '/_authenticated/_admin/admin/manage-users/import': typeof AuthenticatedAdminAdminManageUsersImportRoute
  '/_authenticated/events/$eventId/attendance/add': typeof AuthenticatedEventsEventIdAttendanceAddRoute
  '/_authenticated/_admin/admin/manage-roles/$roleId/edit': typeof AuthenticatedAdminAdminManageRolesRoleIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/about'
    | '/account'
    | '/events'
    | '/feed'
    | '/install-guide'
    | '/notifications'
    | '/register-guest'
    | '/'
    | '/admin'
    | '/account/edit'
    | '/account/feedback'
    | '/account/settings'
    | '/events/$eventId'
    | '/events/new'
    | '/feed/$postId'
    | '/notifications/$notificationId'
    | '/account/'
    | '/events/'
    | '/feed/'
    | '/notifications/'
    | '/admin/guest-log'
    | '/admin/manage-groups'
    | '/admin/manage-roles'
    | '/admin/manage-users'
    | '/admin/moderate-posts'
    | '/events/$eventId/attendance'
    | '/events/$eventId/edit'
    | '/admin/'
    | '/admin/manage-groups/$groupId'
    | '/admin/manage-roles/$roleId'
    | '/admin/manage-roles/new'
    | '/admin/manage-users/import'
    | '/events/$eventId/attendance/add'
    | '/admin/manage-roles/$roleId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/about'
    | '/install-guide'
    | '/register-guest'
    | '/'
    | '/account/edit'
    | '/account/feedback'
    | '/account/settings'
    | '/events/$eventId'
    | '/events/new'
    | '/feed/$postId'
    | '/notifications/$notificationId'
    | '/account'
    | '/events'
    | '/feed'
    | '/notifications'
    | '/admin/guest-log'
    | '/admin/manage-groups'
    | '/admin/manage-roles'
    | '/admin/manage-users'
    | '/admin/moderate-posts'
    | '/events/$eventId/attendance'
    | '/events/$eventId/edit'
    | '/admin'
    | '/admin/manage-groups/$groupId'
    | '/admin/manage-roles/$roleId'
    | '/admin/manage-roles/new'
    | '/admin/manage-users/import'
    | '/events/$eventId/attendance/add'
    | '/admin/manage-roles/$roleId/edit'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/_admin'
    | '/_authenticated/about'
    | '/_authenticated/account'
    | '/_authenticated/events'
    | '/_authenticated/feed'
    | '/_authenticated/install-guide'
    | '/_authenticated/notifications'
    | '/_authenticated/register-guest'
    | '/_authenticated/'
    | '/_authenticated/_admin/admin'
    | '/_authenticated/account/edit'
    | '/_authenticated/account/feedback'
    | '/_authenticated/account/settings'
    | '/_authenticated/events/$eventId'
    | '/_authenticated/events/new'
    | '/_authenticated/feed/$postId'
    | '/_authenticated/notifications/$notificationId'
    | '/_authenticated/account/'
    | '/_authenticated/events/'
    | '/_authenticated/feed/'
    | '/_authenticated/notifications/'
    | '/_authenticated/_admin/admin/guest-log'
    | '/_authenticated/_admin/admin/manage-groups'
    | '/_authenticated/_admin/admin/manage-roles'
    | '/_authenticated/_admin/admin/manage-users'
    | '/_authenticated/_admin/admin/moderate-posts'
    | '/_authenticated/events/$eventId/attendance'
    | '/_authenticated/events/$eventId/edit'
    | '/_authenticated/_admin/admin/'
    | '/_authenticated/_admin/admin/manage-groups/$groupId'
    | '/_authenticated/_admin/admin/manage-roles/$roleId'
    | '/_authenticated/_admin/admin/manage-roles/new'
    | '/_authenticated/_admin/admin/manage-users/import'
    | '/_authenticated/events/$eventId/attendance/add'
    | '/_authenticated/_admin/admin/manage-roles/$roleId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/register-guest': {
      id: '/_authenticated/register-guest'
      path: '/register-guest'
      fullPath: '/register-guest'
      preLoaderRoute: typeof AuthenticatedRegisterGuestRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/install-guide': {
      id: '/_authenticated/install-guide'
      path: '/install-guide'
      fullPath: '/install-guide'
      preLoaderRoute: typeof AuthenticatedInstallGuideRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/feed': {
      id: '/_authenticated/feed'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof AuthenticatedFeedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/events': {
      id: '/_authenticated/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof AuthenticatedEventsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/account': {
      id: '/_authenticated/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/about': {
      id: '/_authenticated/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AuthenticatedAboutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_admin': {
      id: '/_authenticated/_admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications/': {
      id: '/_authenticated/notifications/'
      path: '/'
      fullPath: '/notifications/'
      preLoaderRoute: typeof AuthenticatedNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedNotificationsRoute
    }
    '/_authenticated/feed/': {
      id: '/_authenticated/feed/'
      path: '/'
      fullPath: '/feed/'
      preLoaderRoute: typeof AuthenticatedFeedIndexRouteImport
      parentRoute: typeof AuthenticatedFeedRoute
    }
    '/_authenticated/events/': {
      id: '/_authenticated/events/'
      path: '/'
      fullPath: '/events/'
      preLoaderRoute: typeof AuthenticatedEventsIndexRouteImport
      parentRoute: typeof AuthenticatedEventsRoute
    }
    '/_authenticated/account/': {
      id: '/_authenticated/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AuthenticatedAccountIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/notifications/$notificationId': {
      id: '/_authenticated/notifications/$notificationId'
      path: '/$notificationId'
      fullPath: '/notifications/$notificationId'
      preLoaderRoute: typeof AuthenticatedNotificationsNotificationIdRouteImport
      parentRoute: typeof AuthenticatedNotificationsRoute
    }
    '/_authenticated/feed/$postId': {
      id: '/_authenticated/feed/$postId'
      path: '/$postId'
      fullPath: '/feed/$postId'
      preLoaderRoute: typeof AuthenticatedFeedPostIdRouteImport
      parentRoute: typeof AuthenticatedFeedRoute
    }
    '/_authenticated/events/new': {
      id: '/_authenticated/events/new'
      path: '/new'
      fullPath: '/events/new'
      preLoaderRoute: typeof AuthenticatedEventsNewRouteImport
      parentRoute: typeof AuthenticatedEventsRoute
    }
    '/_authenticated/events/$eventId': {
      id: '/_authenticated/events/$eventId'
      path: '/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof AuthenticatedEventsEventIdRouteImport
      parentRoute: typeof AuthenticatedEventsRoute
    }
    '/_authenticated/account/settings': {
      id: '/_authenticated/account/settings'
      path: '/settings'
      fullPath: '/account/settings'
      preLoaderRoute: typeof AuthenticatedAccountSettingsRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/account/feedback': {
      id: '/_authenticated/account/feedback'
      path: '/feedback'
      fullPath: '/account/feedback'
      preLoaderRoute: typeof AuthenticatedAccountFeedbackRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/account/edit': {
      id: '/_authenticated/account/edit'
      path: '/edit'
      fullPath: '/account/edit'
      preLoaderRoute: typeof AuthenticatedAccountEditRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    '/_authenticated/_admin/admin': {
      id: '/_authenticated/_admin/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminAdminRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/_admin/admin/': {
      id: '/_authenticated/_admin/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminAdminRoute
    }
    '/_authenticated/events/$eventId/edit': {
      id: '/_authenticated/events/$eventId/edit'
      path: '/edit'
      fullPath: '/events/$eventId/edit'
      preLoaderRoute: typeof AuthenticatedEventsEventIdEditRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/events/$eventId/attendance': {
      id: '/_authenticated/events/$eventId/attendance'
      path: '/attendance'
      fullPath: '/events/$eventId/attendance'
      preLoaderRoute: typeof AuthenticatedEventsEventIdAttendanceRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdRoute
    }
    '/_authenticated/_admin/admin/moderate-posts': {
      id: '/_authenticated/_admin/admin/moderate-posts'
      path: '/moderate-posts'
      fullPath: '/admin/moderate-posts'
      preLoaderRoute: typeof AuthenticatedAdminAdminModeratePostsRouteImport
      parentRoute: typeof AuthenticatedAdminAdminRoute
    }
    '/_authenticated/_admin/admin/manage-users': {
      id: '/_authenticated/_admin/admin/manage-users'
      path: '/manage-users'
      fullPath: '/admin/manage-users'
      preLoaderRoute: typeof AuthenticatedAdminAdminManageUsersRouteImport
      parentRoute: typeof AuthenticatedAdminAdminRoute
    }
    '/_authenticated/_admin/admin/manage-roles': {
      id: '/_authenticated/_admin/admin/manage-roles'
      path: '/manage-roles'
      fullPath: '/admin/manage-roles'
      preLoaderRoute: typeof AuthenticatedAdminAdminManageRolesRouteImport
      parentRoute: typeof AuthenticatedAdminAdminRoute
    }
    '/_authenticated/_admin/admin/manage-groups': {
      id: '/_authenticated/_admin/admin/manage-groups'
      path: '/manage-groups'
      fullPath: '/admin/manage-groups'
      preLoaderRoute: typeof AuthenticatedAdminAdminManageGroupsRouteImport
      parentRoute: typeof AuthenticatedAdminAdminRoute
    }
    '/_authenticated/_admin/admin/guest-log': {
      id: '/_authenticated/_admin/admin/guest-log'
      path: '/guest-log'
      fullPath: '/admin/guest-log'
      preLoaderRoute: typeof AuthenticatedAdminAdminGuestLogRouteImport
      parentRoute: typeof AuthenticatedAdminAdminRoute
    }
    '/_authenticated/events/$eventId/attendance/add': {
      id: '/_authenticated/events/$eventId/attendance/add'
      path: '/add'
      fullPath: '/events/$eventId/attendance/add'
      preLoaderRoute: typeof AuthenticatedEventsEventIdAttendanceAddRouteImport
      parentRoute: typeof AuthenticatedEventsEventIdAttendanceRoute
    }
    '/_authenticated/_admin/admin/manage-users/import': {
      id: '/_authenticated/_admin/admin/manage-users/import'
      path: '/import'
      fullPath: '/admin/manage-users/import'
      preLoaderRoute: typeof AuthenticatedAdminAdminManageUsersImportRouteImport
      parentRoute: typeof AuthenticatedAdminAdminManageUsersRoute
    }
    '/_authenticated/_admin/admin/manage-roles/new': {
      id: '/_authenticated/_admin/admin/manage-roles/new'
      path: '/new'
      fullPath: '/admin/manage-roles/new'
      preLoaderRoute: typeof AuthenticatedAdminAdminManageRolesNewRouteImport
      parentRoute: typeof AuthenticatedAdminAdminManageRolesRoute
    }
    '/_authenticated/_admin/admin/manage-roles/$roleId': {
      id: '/_authenticated/_admin/admin/manage-roles/$roleId'
      path: '/$roleId'
      fullPath: '/admin/manage-roles/$roleId'
      preLoaderRoute: typeof AuthenticatedAdminAdminManageRolesRoleIdRouteImport
      parentRoute: typeof AuthenticatedAdminAdminManageRolesRoute
    }
    '/_authenticated/_admin/admin/manage-groups/$groupId': {
      id: '/_authenticated/_admin/admin/manage-groups/$groupId'
      path: '/$groupId'
      fullPath: '/admin/manage-groups/$groupId'
      preLoaderRoute: typeof AuthenticatedAdminAdminManageGroupsGroupIdRouteImport
      parentRoute: typeof AuthenticatedAdminAdminManageGroupsRoute
    }
    '/_authenticated/_admin/admin/manage-roles/$roleId/edit': {
      id: '/_authenticated/_admin/admin/manage-roles/$roleId/edit'
      path: '/edit'
      fullPath: '/admin/manage-roles/$roleId/edit'
      preLoaderRoute: typeof AuthenticatedAdminAdminManageRolesRoleIdEditRouteImport
      parentRoute: typeof AuthenticatedAdminAdminManageRolesRoleIdRoute
    }
  }
}

interface AuthenticatedAdminAdminManageGroupsRouteChildren {
  AuthenticatedAdminAdminManageGroupsGroupIdRoute: typeof AuthenticatedAdminAdminManageGroupsGroupIdRoute
}

const AuthenticatedAdminAdminManageGroupsRouteChildren: AuthenticatedAdminAdminManageGroupsRouteChildren =
  {
    AuthenticatedAdminAdminManageGroupsGroupIdRoute:
      AuthenticatedAdminAdminManageGroupsGroupIdRoute,
  }

const AuthenticatedAdminAdminManageGroupsRouteWithChildren =
  AuthenticatedAdminAdminManageGroupsRoute._addFileChildren(
    AuthenticatedAdminAdminManageGroupsRouteChildren,
  )

interface AuthenticatedAdminAdminManageRolesRoleIdRouteChildren {
  AuthenticatedAdminAdminManageRolesRoleIdEditRoute: typeof AuthenticatedAdminAdminManageRolesRoleIdEditRoute
}

const AuthenticatedAdminAdminManageRolesRoleIdRouteChildren: AuthenticatedAdminAdminManageRolesRoleIdRouteChildren =
  {
    AuthenticatedAdminAdminManageRolesRoleIdEditRoute:
      AuthenticatedAdminAdminManageRolesRoleIdEditRoute,
  }

const AuthenticatedAdminAdminManageRolesRoleIdRouteWithChildren =
  AuthenticatedAdminAdminManageRolesRoleIdRoute._addFileChildren(
    AuthenticatedAdminAdminManageRolesRoleIdRouteChildren,
  )

interface AuthenticatedAdminAdminManageRolesRouteChildren {
  AuthenticatedAdminAdminManageRolesRoleIdRoute: typeof AuthenticatedAdminAdminManageRolesRoleIdRouteWithChildren
  AuthenticatedAdminAdminManageRolesNewRoute: typeof AuthenticatedAdminAdminManageRolesNewRoute
}

const AuthenticatedAdminAdminManageRolesRouteChildren: AuthenticatedAdminAdminManageRolesRouteChildren =
  {
    AuthenticatedAdminAdminManageRolesRoleIdRoute:
      AuthenticatedAdminAdminManageRolesRoleIdRouteWithChildren,
    AuthenticatedAdminAdminManageRolesNewRoute:
      AuthenticatedAdminAdminManageRolesNewRoute,
  }

const AuthenticatedAdminAdminManageRolesRouteWithChildren =
  AuthenticatedAdminAdminManageRolesRoute._addFileChildren(
    AuthenticatedAdminAdminManageRolesRouteChildren,
  )

interface AuthenticatedAdminAdminManageUsersRouteChildren {
  AuthenticatedAdminAdminManageUsersImportRoute: typeof AuthenticatedAdminAdminManageUsersImportRoute
}

const AuthenticatedAdminAdminManageUsersRouteChildren: AuthenticatedAdminAdminManageUsersRouteChildren =
  {
    AuthenticatedAdminAdminManageUsersImportRoute:
      AuthenticatedAdminAdminManageUsersImportRoute,
  }

const AuthenticatedAdminAdminManageUsersRouteWithChildren =
  AuthenticatedAdminAdminManageUsersRoute._addFileChildren(
    AuthenticatedAdminAdminManageUsersRouteChildren,
  )

interface AuthenticatedAdminAdminRouteChildren {
  AuthenticatedAdminAdminGuestLogRoute: typeof AuthenticatedAdminAdminGuestLogRoute
  AuthenticatedAdminAdminManageGroupsRoute: typeof AuthenticatedAdminAdminManageGroupsRouteWithChildren
  AuthenticatedAdminAdminManageRolesRoute: typeof AuthenticatedAdminAdminManageRolesRouteWithChildren
  AuthenticatedAdminAdminManageUsersRoute: typeof AuthenticatedAdminAdminManageUsersRouteWithChildren
  AuthenticatedAdminAdminModeratePostsRoute: typeof AuthenticatedAdminAdminModeratePostsRoute
  AuthenticatedAdminAdminIndexRoute: typeof AuthenticatedAdminAdminIndexRoute
}

const AuthenticatedAdminAdminRouteChildren: AuthenticatedAdminAdminRouteChildren =
  {
    AuthenticatedAdminAdminGuestLogRoute: AuthenticatedAdminAdminGuestLogRoute,
    AuthenticatedAdminAdminManageGroupsRoute:
      AuthenticatedAdminAdminManageGroupsRouteWithChildren,
    AuthenticatedAdminAdminManageRolesRoute:
      AuthenticatedAdminAdminManageRolesRouteWithChildren,
    AuthenticatedAdminAdminManageUsersRoute:
      AuthenticatedAdminAdminManageUsersRouteWithChildren,
    AuthenticatedAdminAdminModeratePostsRoute:
      AuthenticatedAdminAdminModeratePostsRoute,
    AuthenticatedAdminAdminIndexRoute: AuthenticatedAdminAdminIndexRoute,
  }

const AuthenticatedAdminAdminRouteWithChildren =
  AuthenticatedAdminAdminRoute._addFileChildren(
    AuthenticatedAdminAdminRouteChildren,
  )

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminAdminRoute: typeof AuthenticatedAdminAdminRouteWithChildren
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAdminRoute: AuthenticatedAdminAdminRouteWithChildren,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedAccountRouteChildren {
  AuthenticatedAccountEditRoute: typeof AuthenticatedAccountEditRoute
  AuthenticatedAccountFeedbackRoute: typeof AuthenticatedAccountFeedbackRoute
  AuthenticatedAccountSettingsRoute: typeof AuthenticatedAccountSettingsRoute
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute
}

const AuthenticatedAccountRouteChildren: AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountEditRoute: AuthenticatedAccountEditRoute,
  AuthenticatedAccountFeedbackRoute: AuthenticatedAccountFeedbackRoute,
  AuthenticatedAccountSettingsRoute: AuthenticatedAccountSettingsRoute,
  AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
}

const AuthenticatedAccountRouteWithChildren =
  AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren)

interface AuthenticatedEventsEventIdAttendanceRouteChildren {
  AuthenticatedEventsEventIdAttendanceAddRoute: typeof AuthenticatedEventsEventIdAttendanceAddRoute
}

const AuthenticatedEventsEventIdAttendanceRouteChildren: AuthenticatedEventsEventIdAttendanceRouteChildren =
  {
    AuthenticatedEventsEventIdAttendanceAddRoute:
      AuthenticatedEventsEventIdAttendanceAddRoute,
  }

const AuthenticatedEventsEventIdAttendanceRouteWithChildren =
  AuthenticatedEventsEventIdAttendanceRoute._addFileChildren(
    AuthenticatedEventsEventIdAttendanceRouteChildren,
  )

interface AuthenticatedEventsEventIdRouteChildren {
  AuthenticatedEventsEventIdAttendanceRoute: typeof AuthenticatedEventsEventIdAttendanceRouteWithChildren
  AuthenticatedEventsEventIdEditRoute: typeof AuthenticatedEventsEventIdEditRoute
}

const AuthenticatedEventsEventIdRouteChildren: AuthenticatedEventsEventIdRouteChildren =
  {
    AuthenticatedEventsEventIdAttendanceRoute:
      AuthenticatedEventsEventIdAttendanceRouteWithChildren,
    AuthenticatedEventsEventIdEditRoute: AuthenticatedEventsEventIdEditRoute,
  }

const AuthenticatedEventsEventIdRouteWithChildren =
  AuthenticatedEventsEventIdRoute._addFileChildren(
    AuthenticatedEventsEventIdRouteChildren,
  )

interface AuthenticatedEventsRouteChildren {
  AuthenticatedEventsEventIdRoute: typeof AuthenticatedEventsEventIdRouteWithChildren
  AuthenticatedEventsNewRoute: typeof AuthenticatedEventsNewRoute
  AuthenticatedEventsIndexRoute: typeof AuthenticatedEventsIndexRoute
}

const AuthenticatedEventsRouteChildren: AuthenticatedEventsRouteChildren = {
  AuthenticatedEventsEventIdRoute: AuthenticatedEventsEventIdRouteWithChildren,
  AuthenticatedEventsNewRoute: AuthenticatedEventsNewRoute,
  AuthenticatedEventsIndexRoute: AuthenticatedEventsIndexRoute,
}

const AuthenticatedEventsRouteWithChildren =
  AuthenticatedEventsRoute._addFileChildren(AuthenticatedEventsRouteChildren)

interface AuthenticatedFeedRouteChildren {
  AuthenticatedFeedPostIdRoute: typeof AuthenticatedFeedPostIdRoute
  AuthenticatedFeedIndexRoute: typeof AuthenticatedFeedIndexRoute
}

const AuthenticatedFeedRouteChildren: AuthenticatedFeedRouteChildren = {
  AuthenticatedFeedPostIdRoute: AuthenticatedFeedPostIdRoute,
  AuthenticatedFeedIndexRoute: AuthenticatedFeedIndexRoute,
}

const AuthenticatedFeedRouteWithChildren =
  AuthenticatedFeedRoute._addFileChildren(AuthenticatedFeedRouteChildren)

interface AuthenticatedNotificationsRouteChildren {
  AuthenticatedNotificationsNotificationIdRoute: typeof AuthenticatedNotificationsNotificationIdRoute
  AuthenticatedNotificationsIndexRoute: typeof AuthenticatedNotificationsIndexRoute
}

const AuthenticatedNotificationsRouteChildren: AuthenticatedNotificationsRouteChildren =
  {
    AuthenticatedNotificationsNotificationIdRoute:
      AuthenticatedNotificationsNotificationIdRoute,
    AuthenticatedNotificationsIndexRoute: AuthenticatedNotificationsIndexRoute,
  }

const AuthenticatedNotificationsRouteWithChildren =
  AuthenticatedNotificationsRoute._addFileChildren(
    AuthenticatedNotificationsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedAboutRoute: typeof AuthenticatedAboutRoute
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRouteWithChildren
  AuthenticatedEventsRoute: typeof AuthenticatedEventsRouteWithChildren
  AuthenticatedFeedRoute: typeof AuthenticatedFeedRouteWithChildren
  AuthenticatedInstallGuideRoute: typeof AuthenticatedInstallGuideRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRouteWithChildren
  AuthenticatedRegisterGuestRoute: typeof AuthenticatedRegisterGuestRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedAboutRoute: AuthenticatedAboutRoute,
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,
  AuthenticatedEventsRoute: AuthenticatedEventsRouteWithChildren,
  AuthenticatedFeedRoute: AuthenticatedFeedRouteWithChildren,
  AuthenticatedInstallGuideRoute: AuthenticatedInstallGuideRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRouteWithChildren,
  AuthenticatedRegisterGuestRoute: AuthenticatedRegisterGuestRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
